<template>
  <div>
    <SelectorPanel
      type="myIncidents"
      text="Incidents"
      :disabled="disabled"
      :force-close="forceClose"
    >
      <SelectorPanelHeader
        type="myIncidents"
        :title="labelTitle"
        class="pb-2"
        dense
        @click-close="handleClickClose"
      ></SelectorPanelHeader>

      <MyIncidentsContent></MyIncidentsContent>
    </SelectorPanel>
  </div>
</template>

<script>
import {
  MODULE_PREFIX_HOME,
  MODULE_PREFIX_MAP,
  MODULE_PREFIX_MY_INCIDENTS,
  MODULE_PREFIX_USER,
} from "@/store";
import { GET_DETAILS_SIDEBAR, GET_PREFERENCES } from "@/store/actions.type";

import { LABELS } from "@/common/constants/labels";
import { addTileData, removeTileData } from "@/common/maps/features";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { MAP_TILE_SERVER_DYNAMIC } from "@/common/config";
import lodashGet from "lodash/get";
import lodashIsEqual from "lodash/isEqual";
import { MAIN_MAP_ID } from "@/common/constants/maps";
import { mapGetters } from "vuex";

export default {
  name: "MyIncidentsSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel.vue"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader.vue"),
    MyIncidentsContent: () =>
      import("@/components/myIncidents/MyIncidentsContent.vue"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    forceClose: null,
    labelTitle: LABELS.myIncidents,
    layerId: "layer-my-incidents",
    baseTileUrl: `${MAP_TILE_SERVER_DYNAMIC}my_incidents/{z}/{x}/{y}.pbf`,
    options: {
      enabled: undefined,
      search: undefined,
      startDate: undefined,
      endDate: undefined,
    },
  }),
  computed: {
    ...mapGetters({
      maps: MODULE_PREFIX_MAP + "maps",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
      refreshMap: MODULE_PREFIX_MY_INCIDENTS + "refreshMap",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    map() {
      return this.maps[MAIN_MAP_ID];
    },
  },
  mounted() {
    this.getPrefs();
  },
  methods: {
    getPrefs() {
      this.$store.dispatch(MODULE_PREFIX_USER + GET_PREFERENCES);
    },
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
    buildTileUrl() {
      const searchParams = new URLSearchParams();
      if (!!this.options.search) {
        searchParams.append("search", `%${this.options.search}%`);
      }
      if (!!this.options.startDate) {
        searchParams.append("start", this.options.startDate);
      }
      if (!!this.options.endDate) {
        searchParams.append("end", this.options.endDate);
      }

      return searchParams.size > 0
        ? `${this.baseTileUrl}?${searchParams.toString()}`
        : this.baseTileUrl;
    },
    addToMap() {
      this.removeFromMap();

      // draw circle
      let layerOptions = {
        id: `${this.layerId}`,
        source: `${this.layerId}`,
        type: "symbol",
        layout: {
          "icon-image": ["concat", "myincidents_", ["get", "icon"]],
          "icon-size": 0.5,
        },
      };

      layerOptions["source-layer"] = "incidents";
      layerOptions["metadata"] = "seerist-points-incidents";

      let source = {
        type: "vector",
        tiles: [this.buildTileUrl()],
        tolerance: 0,
      };

      let options = {
        id: `${this.layerId}`,
        source: source,
        layerOptions: [layerOptions],
        map: this.map,
        mapClickEvent: this.mapClickEvent,
      };

      addTileData(options);
    },
    async mapClickEvent(e, features) {
      e.originalEvent.stopPropagation();

      if (features.length > 0) {
        this.detailsSidebar.features = features;
        this.detailsSidebar.visible = true;
        this.detailsSidebar.selected = DETAIL_SIDEBAR_TYPES.myIncidents;
        this.detailsSidebar.type = DETAIL_SIDEBAR_TYPES.myIncidents;

        await this.$store.dispatch(
          MODULE_PREFIX_HOME + GET_DETAILS_SIDEBAR,
          this.detailsSidebar
        );
      }
    },
    removeFromMap() {
      if (this.map) {
        removeTileData({
          map: this.map,
          layerId: this.layerId,
          sourceId: this.layerId,
        });
      }
    },
  },
  watch: {
    refreshMap: {
      handler(event) {
        if (lodashIsEqual(event, this.options)) {
          return;
        }

        this.options = {
          ...event,
        };
        if (lodashGet(this.preferences, "myIncidents.enabled")) {
          this.addToMap();
        } else {
          this.removeFromMap();
        }
      },
    },
  },
};
</script>

<style></style>

<style scoped></style>
